var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6612 15.4446C12.84 15.4446 13.9704 14.9763 14.8039 14.1428C15.6374 13.3093 16.1057 12.1788 16.1057 11.0001C16.1057 9.82137 15.6374 8.69091 14.8039 7.85741C13.9704 7.02392 12.84 6.55566 11.6612 6.55566C10.4825 6.55566 9.35204 7.02392 8.51854 7.85741C7.68505 8.69091 7.2168 9.82137 7.2168 11.0001C7.2168 12.1788 7.68505 13.3093 8.51854 14.1428C9.35204 14.9763 10.4825 15.4446 11.6612 15.4446Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66113 15.4444V6.55556C1.66113 5.08213 2.24645 3.66905 3.28832 2.62718C4.33019 1.58532 5.74326 1 7.21669 1H16.1056C17.579 1 18.9921 1.58532 20.0339 2.62718C21.0758 3.66905 21.6611 5.08213 21.6611 6.55556V15.4444C21.6611 16.9179 21.0758 18.3309 20.0339 19.3728C18.9921 20.4147 17.579 21 16.1056 21H7.21669C5.74326 21 4.33019 20.4147 3.28832 19.3728C2.24645 18.3309 1.66113 16.9179 1.66113 15.4444Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7722 4.89992L17.7833 4.8877",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.62ef4bf36df8f06ccb24f34afa939ed5.svg";
export { ForwardRef as ReactComponent };